import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MeServiceDto } from '../classes/me-service-dto';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MeServiceService {

  private meServicesDto$: Observable<MeServiceDto[]>;

  constructor(private http: HttpClient) {
    this.initMeServices(); // Initialize MeServices during the service's construction.
  }

  private initMeServices(): void {
    // Load from local storage if available, else fetch from HTTP.
    const localStorageData = localStorage.getItem('services');
    if (localStorageData) {
      this.meServicesDto$ = of(JSON.parse(localStorageData));
    } else {
      this.fetchMeServices();
    }
  }

  private fetchMeServices(): void {
    this.meServicesDto$ = this.http.get<MeServiceDto[]>('assets/data/services.json').pipe(
      map(data => data.map(item => this.transformData(item))),
      tap(data => this.saveToLocal(data)),  // Side-effect to save data to localStorage
      catchError(this.handleError<MeServiceDto[]>('fetchMeServices', []))
    );
  }

  private saveToLocal(data: MeServiceDto[]): void {
    localStorage.setItem('services', JSON.stringify(data));
  }

  private transformData(data: any): MeServiceDto {
    return {
      id: data.id,
      title: data.title,
      descriptionShort: data['description-short'],
      descriptionComplete: data['description-complete'],
      imageSquare: data['image-square'],
      imagePortada: data['image-portada'],
      category: data.category,
      priceRange: data.priceRange,
      duration: data.duration,
      technology: data.technology,
      tags: data.tags,
      featured: data.featured,
      link: data.link,
      availability: data.availability,
      priority: data.priority,
      prerequisites: data.prerequisites
    };
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);  // Log to console instead
      return of(result as T);
    };
  }

  // Getter to access meServices from other parts of the app
  public get getMeServices(): Observable<MeServiceDto[]> {
    return this.meServicesDto$;
  }

}
